import {CommonModule} from '@angular/common';
import {Component, computed, input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'product-price-cell',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './product-price-cell.component.html',
})
export class ProductPriceCellComponent {
  price = input<number | null | undefined>();
  hasPrice = computed(() => {
    const price = this.price();
    return typeof price === 'number' && !Number.isNaN(price);
  });
}
